import { createSlice } from '@reduxjs/toolkit';
import { DATE_FILTERS } from '@dashboard/constants';

const slice = createSlice({
  name: 'filters',
  initialState: {
    applyFilters: null,
    filters: {
      projects: [],
      countries: [],
      centers: [],
      from: null,
      to: null,
    },
    tmp: {
      projects: [],
      countries: [],
      centers: [],
      from: null,
      to: null,
    },
    options: {
      apply: null,
      readyForNextCall: true,
      dateFilter: DATE_FILTERS[0],
      isFirstLoad: true,
    },
  },
  reducers: {
    setFilter: (state, { payload: obj }) => {
      state.filters = obj;
    },
    setDateFilter: (state, { payload: obj }) => {
      state.options.dateFilter = obj;
    },
    updateTmpFilter: (state, { payload: obj }) => {
      state.tmp = { ...state.tmp, ...obj };
    },
    addTmpFilter: (state, { payload: { key, value } }) => {
      const set = new Set([...(state.tmp[key] || []), value]);
      state.tmp[key] = Array.from(set);
    },
    removeTmpFilter: (state, { payload: { key, value } }) => {
      state.tmp[key] = state.tmp[key].filter((i) => i !== value);
    },
    setTmpFilters: (state, { payload: obj }) => {
      state.tmp = obj;
    },
    updateFilters: (state, { payload: obj }) => {
      state.filters = { ...state.filters, ...obj };
    },
    updateOptions: (state, { payload: obj }) => {
      state.options = { ...state.options, ...obj };
    },
    applyFilters: (state) => {
      state.applyFilters =
        state.filters.centers.length > 0 &&
        state.filters.projects.length > 0 &&
        state.filters.from &&
        state.filters.to
          ? new Date().toISOString()
          : null;
    },
  },
});

export const {
  setFilter,
  updateFilters,
  updateTmpFilter,
  addTmpFilter,
  removeTmpFilter,
  setTmpFilters,
  setDateFilter,
  updateOptions,
  applyFilters,
} = slice.actions;

export default slice.reducer;

export const selectFilter = (state) => state.filters.filters;
export const shouldApplyFilters = (state) => state.filters.applyFilters;
export const dateFilter = (state) => state.filters.options.dateFilter;
export const tmpFilter = (state) => state.filters.tmp;
export const selectOptions = (state) => state.filters.options;

export const selectSelectedCenters = (state) => {
  const allCenters = [];

  state.countries.countries.forEach((country) => {
    allCenters.push(...country.centers);
  });

  return state.filters.filters.centers.map((centerUuid) => {
    return allCenters.find((center) => center.uuid === centerUuid);
  });
};

export const isDateFilterApply = (state) => {
  return (
    state.filters.filters.from === state.filters.tmp.from &&
    state.filters.filters.to === state.filters.tmp.to
  );
};
